<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar">
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{admin_name}}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <logout />
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";

export default {
  components: {
    CollapseTransition
  },
  props: {
    admin_name: {
      type: String
    },
    avatar: {
      type: String,
      default: "/img/custom/dummy_avatar.png"
    }
  },
  data() {
    return {
      isClosed: true,
      user: {}
    };
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
    getLoggedInUser() {
      const authData = this.$store.state.auth.userData;

      if (authData && authData.user) {
        this.user = authData.user.entity;

        this.admin_name = `${authData.user.entity.first_name} ${
          authData.user.entity.last_name
        }`;
      } else {
        this.$router.push("/login");
      }
    }
  },
  created() {
    this.getLoggedInUser();
  }
};
</script>
